import { useEffect, useState } from "react";

import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { InputSearch } from "../../components/InputSearch";
import { Radio } from "../../components/Radio";

import styles from "@styles/containers/oraculo/context-search.module.scss";
import { If } from "shared/components/control-statements";
import { OlgaEnvironmentsAPI } from "../../../providers/OlgaEnvironmentsAPI";

const TYPES = {
  HOLDING: "HOLDING",
  BRAND: "BRAND",
  UNIT: "UNIT",
};

const STEPS = {
  CHOOSE_TYPE: "CHOOSE_TYPE",
  CHOOSE_BRAND: "CHOOSE_BRAND",
  CHOOSE_UNIT: "CHOOSE_UNIT",
};

export default function ContextSearch({ visible, onClose, onChangeContext }) {
  const [brands, setBrands] = useState([]);
  const [context, setContext] = useState({ type: TYPES.HOLDING });
  const [brandSearchTerm, setbrandSearchTerm] = useState("");
  const [unitSearchTerm, setUnitSearchTerm] = useState("");
  const [step, setStep] = useState(STEPS.CHOOSE_TYPE);

  useEffect(() => {
    const loadFilterOptions = async () => {
      const unitsResponse = await OlgaEnvironmentsAPI.getUnits();
      const units = unitsResponse.getData([]);

      const brandsResponse = await OlgaEnvironmentsAPI.getBrands();
      const brands = brandsResponse.getData([]);

      if ((units || []).length > 0) {
        for (const brand of brands)
          brand.units = (units || []).filter(
            (unit) => unit.brand_id === brand.id
          );
      }

      setBrands(brands);
    };

    loadFilterOptions();
  }, []);

  const changeContext = (data) => {
    setContext({ ...data });
  };

  const next = () => {
    if (step === STEPS.CHOOSE_BRAND) {
      return setStep(STEPS.CHOOSE_UNIT);
    }

    switch (context?.type) {
      case TYPES.HOLDING:
        return onClose();
      case TYPES.BRAND:
        return setStep(STEPS.CHOOSE_BRAND);
      case TYPES.UNIT:
        return setStep(STEPS.CHOOSE_BRAND);
      default:
        return;
    }
  };

  const save = () => {
    onChangeContext({
      ...context,
      multi_brand: brands.length > 1,
    });
  };

  const getTitle = () => {
    switch (step) {
      case STEPS.CHOOSE_TYPE:
        return "Filtragem por contexto";
      case STEPS.CHOOSE_BRAND:
        return "Seletor de unidade ativa";
      case STEPS.CHOOSE_UNIT:
        return "Selecionar unidade";
      default:
        return "";
    }
  };

  const selectedBrand = brands.filter((a) => a.id === context?.brand?.id)?.[0];

  const filteredBrands = brands.filter((brand) => {
    return !!brandSearchTerm
      ? brand.name.toLowerCase().indexOf(brandSearchTerm.toLowerCase()) > -1
      : true;
  });

  const filteredUnits = selectedBrand?.units?.filter((unit) => {
    return !!unitSearchTerm
      ? unit.name.toLowerCase().indexOf(unitSearchTerm.toLowerCase()) > -1
      : true;
  });

  const getSubtitle = () => {
    if (step === STEPS.CHOOSE_BRAND && context?.type === TYPES.UNIT) {
      return "Selecionar unidade";
    }

    if (step === STEPS.CHOOSE_UNIT) {
      return `${selectedBrand.name}`;
    }

    if (step === STEPS.CHOOSE_BRAND) {
      return "Selecionar marca";
    }

    return "";
  };

  const checkNextEnabled = () => {
    return (
      (step === STEPS.CHOOSE_TYPE && !context?.type) ||
      (step === STEPS.CHOOSE_BRAND && !context?.brand) ||
      (step === STEPS.CHOOSE_UNIT && !context?.unit)
    );
  };

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title={getTitle()}
      subtitle={getSubtitle()}
      showBackButton={step !== STEPS.CHOOSE_TYPE}
      backButton={() => {
        setStep(
          step === STEPS.CHOOSE_UNIT ? STEPS.CHOOSE_BRAND : STEPS.CHOOSE_TYPE
        );
      }}
    >
      <div className={styles.scrollContainer}>
        {step === STEPS.CHOOSE_TYPE ? (
          <>
            <If cond={brands.length > 1}>
              <div
                className={styles.type}
                onClick={() =>
                  setContext({
                    type: TYPES.HOLDING,
                  })
                }
              >
                <p>Selecionar holding</p>
                <Radio
                  family="type"
                  value={true}
                  checked={context?.type === TYPES.HOLDING}
                  readOnly
                />
              </div>
              <div
                className={styles.type}
                onClick={() =>
                  setContext({
                    type: TYPES.BRAND,
                  })
                }
              >
                <p>Selecionar marca</p>
                <Radio
                  family="type"
                  value={true}
                  checked={context?.type === TYPES.BRAND}
                  readOnly
                />
              </div>
            </If>
            <If cond={brands.length == 1}>
              <div
                className={styles.type}
                onClick={() => setContext({ type: TYPES.HOLDING })}
              >
                <p>Selecionar marca</p>
                <Radio
                  family="type"
                  value={true}
                  checked={context?.type === TYPES.HOLDING}
                  readOnly
                />
              </div>
            </If>
            <div
              className={styles.type}
              onClick={() =>
                setContext({
                  type: TYPES.UNIT,
                })
              }
            >
              <p>Selecionar unidade</p>
              <Radio
                family="type"
                value={true}
                checked={context?.type === TYPES.UNIT}
                readOnly
              />
            </div>
          </>
        ) : null}

        {step === STEPS.CHOOSE_BRAND ? (
          <>
            <InputSearch
              placeholder="Buscar por..."
              className="mb-20"
              design="two"
              onChange={(e) => setbrandSearchTerm(e.target.value)}
            />

            {context?.type === TYPES.BRAND
              ? filteredBrands.map((brand) => {
                  return (
                    <div
                      className={styles.brand}
                      onClick={() =>
                        changeContext({
                          ...context,
                          brand,
                        })
                      }
                    >
                      <p>{brand.name}</p>
                      <Radio
                        family="brand"
                        value={true}
                        checked={context?.brand?.id === brand.id}
                        readOnly
                      />
                    </div>
                  );
                })
              : null}

            {context?.type === TYPES.UNIT
              ? filteredBrands.map((brand) => {
                  return (
                    <div
                      className={styles.brandAndUnits}
                      onClick={() => {
                        changeContext({
                          ...context,
                          brand,
                        });

                        next();
                      }}
                    >
                      <p>{brand.name}</p>
                      <div className="d-flex align-center">
                        <span className={styles.units}>
                          {brand?.units?.length} unidades
                        </span>
                        <div className={styles.chevron}>
                          <i className="fas fa-chevron-right" />
                        </div>
                      </div>
                    </div>
                  );
                })
              : null}
          </>
        ) : null}

        {step === STEPS.CHOOSE_UNIT ? (
          <>
            <InputSearch
              placeholder="Buscar por..."
              className="mb-20"
              design="two"
              onChange={(e) => setUnitSearchTerm(e.target.value)}
            />

            {filteredUnits?.map((unit) => {
              return (
                <div
                  className={styles.unit}
                  onClick={() =>
                    changeContext({
                      ...context,
                      unit,
                    })
                  }
                >
                  <p>{unit.name}</p>
                  <Radio
                    family="unit"
                    value={true}
                    checked={context?.unit?.id === unit.id}
                    readOnly
                  />
                </div>
              );
            })}
          </>
        ) : null}
      </div>

      <div className={styles.footer}>
        {!(step === STEPS.CHOOSE_BRAND && context?.type === TYPES.UNIT) ? (
          <>
            {(step === STEPS.CHOOSE_TYPE && context?.type === TYPES.HOLDING) ||
            (step === STEPS.CHOOSE_BRAND && context?.brand) ||
            (step === STEPS.CHOOSE_UNIT && context?.unit) ? (
              <Button
                design="primary"
                className="w-100"
                disabled={checkNextEnabled()}
                onClick={save}
              >
                Salvar
              </Button>
            ) : (
              <Button
                design="primary"
                className="w-100"
                disabled={checkNextEnabled()}
                onClick={next}
              >
                Próximo
              </Button>
            )}
          </>
        ) : null}
      </div>
    </Drawer>
  );
}
